import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import Container from '@material-ui/core/Container';
import styles from "./Common.module.scss"
import { data } from './local';
import { Menu, MenuItem, Select, TextareaAutosize } from '@material-ui/core';
import SearchBox from './SearchBox';
import { eventEmitter, getAutoSaveVal, getCategoryMap, getDraftMode, getemailNotificationEabled, getIsAnonymous, getNominatorHashedMail, getNominatorId, getNominatorMail, getNominatorName, getSubmitMode, getToken, getUserGraphId, setAutoSaveVal } from './common';
import { InputType } from 'zlib';
import { useLocation } from "react-router-dom";
import { UserImage } from "./SearchBox";
import { getNominatorInfo, insertNomination, sendMail, updateNominationStateAfterSendingEmails } from "./services"
import { useHistory } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Link } from 'react-router-dom';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { autoSaveTime } from './constants';
import {sendNominatorMail, sendNomineeMail, sendNomineeManagerMail} from './Mail';
import { appInsights } from '../AppInsights';
import { getIsEnabled } from './common';
import { isNotNullOrUndefined } from '@microsoft/applicationinsights-core-js';
import { getClosureData } from './services';


const NomineeNotes: FunctionComponent<any> = () => {

    let location = useLocation();

    const getcorrelationId = () => {
        return sessionStorage.getItem("correlationId");
      }
    
    const { id, token, name, mail, jobTitle, officeLocation, nomineeId, nomineeManagerEmail } = location.state;
    const handleBack = async () => {
        await insertNominationData(true);
        history.push("/");
    }

    const [value, setValue] = useState<any>(getAutoSaveVal());
    const [isEnabled, enable] = useState<boolean>(false);
    const [isAnonymous, anonymous] = useState<boolean>(false);
    const [saveValue, setSave] = useState<any>("");
    const state = React.useRef<boolean>();
    const saveNom = React.useRef<boolean>();

    let history = useHistory();

    useEffect(() => {
        setAutoSaveVal(value);
        
        if (value.length >= 500) {
            enable(true)
        } else {
            enable(false)
        }
    }, [value])
    useEffect(() => {
       let anonymousVal= getIsAnonymous();
       anonymous(anonymousVal);
    }, [])

    useEffect(() => {
        const interval = setInterval(async () => {
            if(saveNom.current)
            {
                await insertNominationData(true);
                setSave(nominationEditor.saved);
            }
        }, autoSaveTime);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        getClosureData().then((response: any) => {
            if (response != null) {
                state.current = !response.toggleState;
                saveNom.current = true;
            }
        });
    }, [])

    const handleChange = (event: any) => {
        setValue(event.target.value);
        setSave(nominationEditor.saving);
    }

    const insertNominationData = async (isDraft: boolean) => {
        const { id, token, name, jobTitle, officeLocation, nomineeId, nomineeManagerName, nomineeManagerEmail } = location.state;
        let options = {
            "title": jobTitle,
            "nominatorId": getNominatorId(),
            "nomineeId": nomineeId,
            "nominatorEmailHash": getNominatorHashedMail(),
            "notes": getAutoSaveVal(),
            "state": isDraft ? getDraftMode() : getSubmitMode(),
            "categoryId": getCategoryMap().get("via nominations"),//current Nomination needed remove hardcoading
            "groupName": "",
            "groupEmail": "",
            "nominationYear": (state.current) ? new Date().getFullYear() + 1 : new Date().getFullYear(),
            "isAnonymous": isAnonymous,
            "managerName": nomineeManagerName,
            "managerEmail": nomineeManagerEmail
        }
        
        let result = await insertNomination(options);

        if (!isDraft && result.status == "Successfully submitted the Nomination") {
            appInsights.trackEvent({ name: "AfterSubmittingTheNominationBeforeSendingEmail", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId() } })
            sendMail();
            await updateNominationStateAfterSendingEmails(options);
            appInsights.trackEvent({ name: "AfterSubmittingTheNominationAfterSendingEmail", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId() } })
            history.push("thankYou", {})
        }

        if ((!isAnonymous && !isDraft)) {
            appInsights.trackEvent({ name: "NominationSubmitted", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId() } })
        }

        else if ((isAnonymous && !isDraft)) {
            appInsights.trackEvent({ name: "AnonymousNominationSubmitted", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId() } })
        }
        eventEmitter.emit("nominated", null);

    }

    const handleSubmit = (event: any) => {
        insertNominationData(false);
        event.preventDefault();
    }

    const handleDraft = (event: any) => {
        insertNominationData(true);
        event.preventDefault();
        history.push("thankYou", {});
    }

    const sendMail = async () => {
        const { name, mail,  nomineeManagerName, nomineeManagerEmail } = location.state;
        let Nominatordetails = {
            "name": name
        }
        let Nomineedetails = {
            "name": name,
            "mail": mail,
            "isAnonymous": isAnonymous,
        }
        let NomineeMgrdetails = {
            "name": name,
            "managerName": nomineeManagerName,
            "managerEmail": nomineeManagerEmail,
            "isAnonymous": isAnonymous,
            "nominatorName": getNominatorName(),
            "nominationYear": (state.current) ? new Date().getFullYear() + 1 : new Date().getFullYear(),
            "nominationNotes": getAutoSaveVal()
        }
        sendNominatorMail(Nominatordetails);
        sendNomineeMail(Nomineedetails);
        if (isNotNullOrUndefined(nomineeManagerEmail) && nomineeManagerEmail != "NA") {
            sendNomineeManagerMail(NomineeMgrdetails);
        }
        else {
            appInsights.trackEvent({ name: "CannotSendMailToManager", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId()} });
        }
    }

    const handleAnonymousChange = (event: any) => {
        isAnonymous ? anonymous(false) : anonymous(true)
        isAnonymous?setOpen(false):setOpen(true);
    }
    
    const [open, setOpen] = React.useState(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
      };
    const handleAgree = () => {
        handleClose();
        anonymous(true);
        
        
    };
    const handleDisagree = () => {
        
        handleClose();
        anonymous(false);
    };
     const languageSelected:any = useSelector((state:any) => state.lang);
    const languageData: any = data;

    const { nominationEditor } = languageData[languageSelected];


    return (
        <React.Fragment>
            <Container maxWidth={"xl"} style={{ background: "#ffffff", minHeight:'100vh'}} >

                {/* <SubmitNotes className={styles.outerComponent}/> */}
                <div className={styles.nominaionEditor}  >
                    <div className={styles.BackNavEditor}><ArrowBackIosIcon /><span onClick={handleBack}>{nominationEditor.back}</span></div>
                    {/* <DisplayText /> */}
                    <div className={styles.messageBox + " " + styles.mb5}>{nominationEditor.intro}</div>
                    <div className={styles.mb10 + " " + styles.barlow} >{nominationEditor.sampleWriteUp}<Link to="/thoughtStarters">{nominationEditor.writeUpLink}</Link></div>
                    {/* <NomineeProfile /> */}
                    <div style={{ display: "flex", flexDirection: "row", marginBottom: "10px" }}>
                        <div style={{ float: "left", marginRight: 20 }}>
                            <UserImage id={id} token={token} />
                        </div>
                        <div>
                            <span className={styles.barlow}>{name}</span><br />
                            <span className={styles.barlow}>{jobTitle}</span><br />
                            <span className={styles.barlow}>{officeLocation}</span>
                        </div>
                    </div>
                    {/* <NotesArea previousData={location.state} /> */}
                    <form onSubmit={handleSubmit}>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <TextareaAutosize style={{ width: "inherit", height: 300, maxWidth: "934px", whiteSpace:"pre-line" , overflow:"scroll"}} className={styles.mb10} aria-label="empty textarea" placeholder={nominationEditor.textBoxPlaceHolder} value={value.replace(/\s{6,}/g, ' ')} onChange={handleChange} maxLength={5000} />
                            <div>
                            <span style={{ color: value.length >= 500 ? "black" : "red" }}>{value.length} {nominationEditor.of} 5000 {nominationEditor.characters}{nominationEditor.minimum}</span>
                            <span style={{ float:"right",color:"red" }}>{saveValue}</span><br /><br />
                            </div>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                <div style={{ display: "flex", flexDirection: "row", position: "relative" }}>
                                    <Checkbox
                                        checked={isAnonymous}
                                        onChange={handleAnonymousChange}
                                        name="anomyousCheck"
                                        style ={{
                                            color: "#00338E",
                                          }}
                                    /><span style={{
                                        whiteSpace: "nowrap",
                                        margin: "auto",
                                        fontSize: "2vmin"
                                    }}>{nominationEditor.submitAnonymously}</span>
                                </div>
                                <Dialog
                                   
                                    open={open}
                                    onClose={handleClose}
                                    aria-labelledby="responsive-dialog-title"
                                 >
                                <DialogTitle id="responsive-dialog-title" style={{height:'16px', backgroundColor: '#00338e', fontFamily: 'barlow', color: '#FFFFFF' }}>{nominationEditor.submitAnonymously}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText>
                                        {nominationEditor.confirmationText}
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                <Button className={styles.messageBoxEditor} onClick={handleAgree} color="primary" autoFocus>
                                     {nominationEditor.yes}
                                </Button>
                                <Button className={styles.messageBoxEditor} autoFocus onClick={handleDisagree} color="primary">
                                    {nominationEditor.no}
                                </Button>
                                </DialogActions>
                                </Dialog>
                                <div style={{ display: "flex", flexDirection: "row", gap: "10px"}}>
                                <Button className={styles.AddAwardeeBttn} onClick={handleDraft} value="Save As Draft" variant="contained">{nominationEditor.draft}</Button>
                                <Button type="submit" className={isEnabled ? styles.AddAwardeeBttn : styles.AddAwardeeBttndisabled} disabled={!isEnabled} value="Submit" color="primary" variant="contained">{nominationEditor.submit}</Button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </Container>
        </React.Fragment>
    );
}



// const useStyles = makeStyles((theme: Theme) =>
//   createStyles({
//     root: {
//       display: 'flex',
//       '& > * + *': {
//         marginLeft: theme.spacing(2),
//       },
//     },
//   }),
// );

// export  function CircularDeterminate() {
//   const classes = useStyles();
//   const [progress, setProgress] = React.useState(0);

//   React.useEffect(() => {
//     const timer = setInterval(() => {
//       setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 10));
//     }, 800);

//     return () => {
//       clearInterval(timer);
//     };
//   }, []);

//   return (
//     <div className={classes.root}>
//       <CircularProgress variant="determinate" value={25} />
//       <CircularProgress variant="determinate" value={50} />
//       <CircularProgress variant="determinate" value={75} />
//       <CircularProgress variant="determinate" value={100} />
//       <CircularProgress variant="determinate" value={progress} />
//     </div>
//   );
// }



export default NomineeNotes;